import {
  Building2, FileText, Scale, Factory, UtensilsCrossed, Ruler, Flame,
  Home as HomeIcon, Lightbulb, FileSignature, Briefcase, Search,
  Ship, CalendarCheck, Users,
} from "lucide-react";

// Full service catalog for KaveriBiz Corporate Services LLP
export const SERVICES = [
  {
    slug: "business-registration",
    title: "Business Registration & Corporate Formation",
    tagline: "Seamless company incorporation and business setup.",
    icon: Building2,
    accent: "from-[#d4a840]/20 to-transparent",
    items: [
      "Private Limited Company", "One Person Company (OPC)", "Limited Liability Partnership (LLP)",
      "Partnership Firm", "Proprietorship", "Section 8 Company", "Producer Company",
      "Trust", "Society", "Nidhi Company", "PAN, TAN, DIN, DSC",
      "UDYAM Registration", "Startup India", "Professional Tax",
    ],
  },
  {
    slug: "corporate-secretarial-roc",
    title: "Corporate Secretarial & ROC Compliance",
    tagline: "Annual filings, board meetings and governance done right.",
    icon: FileText,
    items: [
      "Annual ROC Filing", "LLP Annual Compliance", "AGM & Board Meetings",
      "Director Appointment / Resignation", "Registered Office / Company Name Change",
      "Share Transfer", "Rights Issue", "Preferential Allotment",
      "Strike Off & Revival", "Corporate Governance", "Secretarial Due Diligence",
    ],
  },
  {
    slug: "labour-law",
    title: "Labour Law Compliance",
    tagline: "Workforce compliance from EPF/ESI to POSH & audits.",
    icon: Scale,
    items: [
      "Shops & Establishments", "Factory Licence", "Contract Labour",
      "EPF & ESI", "Standing Orders", "Labour Audit & Due Diligence",
      "POSH", "Employment Agreements", "HR Policies",
    ],
  },
  {
    slug: "industrial-licensing",
    title: "Industrial Licensing",
    tagline: "Trade, boiler, electrical, petroleum & warehouse approvals.",
    icon: Factory,
    items: [
      "Trade Licence", "Boiler Licence", "Lift Licence",
      "Electrical Licence", "Petroleum & Explosives", "Warehouse Licence",
    ],
  },
  {
    slug: "food-business-fssai",
    title: "Food Business & FSSAI",
    tagline: "FSSAI licensing at every scale + labelling compliance.",
    icon: UtensilsCrossed,
    items: [
      "FSSAI Basic", "FSSAI State", "FSSAI Central",
      "FSSAI Renewal", "Food Labelling",
    ],
  },
  {
    slug: "legal-metrology",
    title: "Legal Metrology",
    tagline: "Manufacturer, importer and packer registrations.",
    icon: Ruler,
    items: [
      "Manufacturer / Importer / Packer Registration",
      "Weights & Measures Approval", "Model Approval",
      "Packaged Commodity Compliance",
    ],
  },
  {
    slug: "fire-environmental",
    title: "Fire & Environmental",
    tagline: "Fire NOC, CTE/CTO and waste management approvals.",
    icon: Flame,
    items: [
      "Fire NOC", "Consent to Establish (CTE)", "Consent to Operate (CTO)",
      "Environmental Clearance", "Hazardous, Biomedical & Plastic Waste",
      "E-Waste & Battery Waste", "Environmental Audit",
    ],
  },
  {
    slug: "property-legal",
    title: "Property Legal Services",
    tagline: "Deeds, registrations, title verification and legal opinion.",
    icon: HomeIcon,
    items: [
      "Sale / Gift / Release / Partition Deeds", "Mortgage & Lease Agreements",
      "Property Registration", "Khata & Encumbrance Certificate",
      "Property Due Diligence", "Title Verification", "Legal Opinion",
    ],
  },
  {
    slug: "intellectual-property",
    title: "Intellectual Property",
    tagline: "Trademarks, copyrights, designs and IP portfolios.",
    icon: Lightbulb,
    items: [
      "Trademark Registration", "Copyright", "Patent Coordination",
      "Design Registration", "Geographical Indication (GI)", "IP Portfolio Management",
    ],
  },
  {
    slug: "contracts",
    title: "Contracts & Legal Documentation",
    tagline: "Every commercial paper your business will ever sign.",
    icon: FileSignature,
    items: [
      "Commercial / Service / Vendor / Supply Agreements",
      "Manufacturing & Distribution Agreements", "Employment Agreements",
      "MoU & NDA", "Shareholders & JV Agreements", "Legal Notices",
    ],
  },
  {
    slug: "corporate-advisory",
    title: "Corporate Advisory",
    tagline: "Compliance calendars, audits and legal opinions.",
    icon: Briefcase,
    items: [
      "Compliance Audit", "Compliance Calendar", "Vendor Compliance",
      "Risk Assessment", "Legal Opinions",
    ],
  },
  {
    slug: "due-diligence-transactions",
    title: "Due Diligence & Transaction Advisory",
    tagline: "M&A, share purchase, corporate restructuring & DD.",
    icon: Search,
    items: [
      "Legal / Regulatory / Commercial DD",
      "Financial & Tax DD (with CA)", "GST & Customs DD",
      "Labour / Secretarial / Contract / IP DD", "ESG & Litigation DD",
      "M&A Advisory & Share/Asset Purchase", "Corporate Restructuring",
      "Transaction Documentation",
    ],
  },
  {
    slug: "import-export-customs",
    title: "Import Export & Customs",
    tagline: "IEC, DGFT, EPCG and customs advisory & litigation.",
    icon: Ship,
    items: [
      "IEC Registration", "DGFT Compliance", "Advance Authorisation",
      "EPCG", "Customs Compliance & Advisory", "Customs Litigation",
    ],
  },
  {
    slug: "annual-compliance",
    title: "Annual Compliance Programme",
    tagline: "A single subscription for total statutory calm.",
    icon: CalendarCheck,
    items: [
      "ROC", "GST", "Labour", "Trade Licence",
      "Factory Licence", "FSSAI", "Legal Metrology",
      "Pollution", "Fire NOC",
    ],
  },
  {
    slug: "hr-services",
    title: "KaveriBiz HR Services",
    tagline: "End-to-end HR support from hiring to exit.",
    icon: Users,
    items: [
      "Employee Documentation", "Recruitment & Onboarding",
      "Attendance & Leave Management", "Payroll & Payslip Services",
      "HR Policies & Documentation", "Employee Exit & Disciplinary Documentation",
      "HR Compliance & Monthly Reports",
    ],
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
